module.exports = __webpack_public_path__ + "img/avatar.5e357f48.png";